<template>
  <el-dialog :title="title" v-model="show" size="full">
    <div v-loading="loading" :element-loading-text="type === 0 ? '修改保存中。。。' : '新增保存中。。。'">
      <div>
        <el-button @click='addSolution'>新增解题过程</el-button>
      </div>
      <solution-table :tableData="solutionList" ></solution-table>
    </div>
  </el-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'
  import solutionTable from '@/components/solutionTable/solutionTable'
  import solutionDlg from '@/components/solutionDlg'

  export default {
    data () {
      return {
        show: false,
        loading: false,
        tempstr: '',
        guid: '',
        tmguid: '',
        id: -1
      }
    },
    computed: {
      ...mapGetters([
        'solutionList'
      ]),
      title () {
        return `解题过程列表`
      }
    },
    created () {
      // console.log('-----00000000000---------this.tmguid=' + this.tmguid)
      // this.$store.dispatch('actions_getSolutionList', this.tmguid)
    },
    components: {
      solutionTable,
      solutionDlg
    },
    watch: {
      show: function (val) {
        if (val) {
          this.$store.dispatch('actions_getSolutionList', this.tmguid)
        }
      }
    },
    methods: {
      addSolution () {
        solutionDlg({
          isEditData: false,
          tmguid: this.tmguid
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// main.vue?abc3d660